// John Eldhose 20180523
import { RestfulGet } from './Restful';

export async function ManageAccountADT() {
  const com = await RestfulGet('ManageAccountADT', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return com;
}



// WEBPACK FOOTER //
// ./src/Api/ManageAccountADT.js